import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-textcounter', 'remaining', 'символов');
Labels.set('ui-textcounter', 'invalid', 'Используйте не более %d символов.');
